import { Space } from 'antd';
import dayjs from 'dayjs';
import * as React from 'react';
import { memo, useContext } from 'react';
import { localize } from '/react4xp/mixins/helpers';
import { ComponentContext } from '/react4xp/parts/knowledge-base/knowledge-base';

interface ArticleStaticticsProps {
    views: number;
    coincidenceCount?: number;
    published: string;
}

const ArticleStatistics = memo(({ published, views, coincidenceCount }: ArticleStaticticsProps) => {
    const { translations } = useContext(ComponentContext);
    return (
        <Space
            size={24}
            style={{ maxWidth: 'calc(100% - 150px)' }}
        >
            <p className="muted">
                {localize('published', translations)}: {dayjs(published).format('DD.MM.YYYY')}
            </p>
            <p className="muted">
                {localize('views', translations).replace('__COUNT__', views.toString())}
            </p>
            {typeof coincidenceCount != 'undefined' && (
                <p className="muted">
                    {localize('knowledge-base.coincidence-count', translations).replace(
                        '__COUNT__',
                        coincidenceCount.toString()
                    )}
                </p>
            )}
        </Space>
    );
});

export default ArticleStatistics;
